import { UseFormReturn } from "react-hook-form";
import { clientOnboardingType } from "@/pages/AppCreation/validator";
// import EditIcon from "@/components/icons/EditIcon";
import useCurrentUserStore from "@/store";
import WhiteLogo from "@/components/icons/WhiteLogo";

type PropTypes = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<clientOnboardingType, any, undefined>;
};

const Step2ContentPreview: React.FC<PropTypes> = (props) => {
  const { selectedApp } = useCurrentUserStore();
  const step2Data = props.form.watch("step2");
  const step1Data = props.form.watch("step1");

  return (
    <div className="p-6 lg:p-0 bg-primary lg:rounded-[20px] shadow-md lg:max-w-[59vw] lg:w-[60vw] text-white flex flex-col justify-end lg:items-center lg:h-[calc(100%-0.5rem)] lg:relative lg:object-cover lg:mt-1">
      <WhiteLogo />
      <div
        className={`bg-none lg:bg-[url('/bg-frame.png')] bg-no-repeat bg-cover min-h-[28rem] max-h-[45rem] h-[90%] lg:min-w-[28rem] max-w-[50rem] w-[95%] lg:absolute lg:right-0`}
      >
        <div className="flex flex-col gap-6 mt-[16%] ml-[2rem] lg:ml-[8rem] w-[48%]">
          <h4 className="text-2xl font-bold ml-2">My Apps</h4>
          <div className="flex flex-col gap-0 lg:min-h-[7rem] h-[10.5rem] w-[18rem] bg-white rounded-[8px] p-4">
            <div className="flex gap-2 items-center ">
              {!selectedApp?.icon ? (
                // <EditIcon />
                <img src="/pen-icon.svg" alt="icon" className="w-8 mb-2" />
              ) : (
                <img
                  src={selectedApp?.icon}
                  alt="icon"
                  className="w-5 h-auto"
                />
              )}
              <h5 className="text-[#0f172a] text-base font-semibold w-36">
                {step1Data.appTemplateName}
              </h5>
            </div>
            <div className="flex flex-col gap-2 max-w-56">
              <h5 className="text-[#0f172a] text-base font-semibold truncate">
                {step2Data.appName}
              </h5>
              <p className="text-[#64748b] text-xs truncate">{`${step2Data.appUrl}.${selectedApp?.url}`}</p>
              <p className="text-[#64748b] text-xs truncate">
                {step2Data.description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step2ContentPreview;
